<template>
  <div>
    <b-form-group label="Nome Fantasia:">
      <b-form-input
        v-model="valueForm.nome"
        placeholder="Nome Fantasia"
        :state="validateState('nome')"
      ></b-form-input>
      <b-form-invalid-feedback>
        Nome é um campo obrigatório.
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Razão Social:">
      <b-form-input
        v-model="valueForm.razao_social"
        placeholder="Razão Social"
        :state="validateState('razao_social')"
      ></b-form-input>
      <b-form-invalid-feedback>
        Razão Social é um campo obrigatório.
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="CNPJ:">
      <b-form-input
        v-model="valueForm.cnpj"
        :formatter="formatterCnpj"
        placeholder="CNPJ"
        :state="validateState('cnpj')"
      ></b-form-input>
      <b-form-invalid-feedback>
        CNPJ é um campo obrigatório.
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Inscrição Estadual:">
      <b-form-input
        v-model="valueForm.ie"
        placeholder="Inscrição Estadual"
        :state="validateState('ie')"
      ></b-form-input>
      <b-form-invalid-feedback>
        Inscrição Estadual é um campo obrigatório.
      </b-form-invalid-feedback>
    </b-form-group>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { cnpj } from "cpf-cnpj-validator";
import getLegalPersonEmpty from "@/components/Form/PessoaJuridica/get_legal_person_empty";

export default {
  mixins: [validationMixin],
  data: () => ({}),
  props: {
    value: {},
    cnpj_invalid: {
      default: null,
    },
    optionalFields: {
      type: Array,
      default: () => [],
    },
  },
  validations() {
    const defaultValidations = {
      value: {
        nome: {
          required,
          minLength: minLength(3),
        },
        razao_social: {
          required,
          minLength: minLength(3),
        },
        cnpj: {
          required,
          cnpj: (value) => {
            return !value || cnpj.isValid(value);
          },
          is_unique(value) {
            return value != this.cnpj_invalid;
          },
        },
        ie: {},
      },
    };

    this.optionalFields.forEach((key) => {
      if (defaultValidations.value[key].required) {
        delete defaultValidations.value[key].required;
      }
    });

    return defaultValidations;
  },
  computed: {
    _cnpj: {
      set(value) {
        value = value.replace(/\D/g, "").substring(0, 14);
        this.value.cnpj = value;
      },
      get() {
        let value = this.value.cnpj.replace(
          /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          "$1.$2.$3/$4-$5"
        );
        return value;
      },
    },
    valueForm: {
      get() {
        return this.value || {};
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.value[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.value.$touch();
      return !this.$v.value.$anyError;
    },
    formatterCnpj(value) {
      const cnpjPattern = /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/;
      const formattedValue = value
        .replace(/\D/g, "")
        .substring(0, 14)
        .replace(cnpjPattern, "$1.$2.$3/$4-$5");

      return formattedValue;
    },
  },
  mounted() {
    const legalPersonInfo = Object.assign({}, getLegalPersonEmpty, this.value);
    this.$emit("input", legalPersonInfo);
  },
  beforeDestroy() {
    this.$emit("input", getLegalPersonEmpty);
  },
};
</script>
